import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { flexCenter, focusStyle } from '../styles/mixins';
import { fontText, hexToRgbA, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => {
  const elementColor = theme.color.greys[0];

  return createStyles({
  root: {
    ...flexCenter(),
    [theme.breakpoints.down('sm')]: {
      gap: 16,
      flexWrap: 'wrap',
    },
    '& .MuiPagination-root': {
      marginLeft: 'auto',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
      },
    }
  },
  paginationList: {
    '& > li:first-child, & > li:last-child': {
      '& .MuiPaginationItem-root': {
        color: theme.color.greys[80],
        border: 'none',
        '&:hover': {
          border: 'none',
          borderRadius: 80,
          color: elementColor,
          backgroundColor: theme.color.greys[80],
        },
        '&:active': {
          backgroundColor: theme.color.greys[60],
        },
        '&.Mui-disabled': {
          color: hexToRgbA(theme.color.greys[80], 0.4),
          border: 'none',
        }
      },
      '& .MuiPaginationItem-page': {
        color: theme.color.greys[80],
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&:active': {
          backgroundColor: theme.color.greys[60],
        }
      }
    },
    '& .MuiPaginationItem-root': {
      font: fontText('normal', theme.fontSize.m, 28),
      color: theme.color.greys[80],
      margin: 6,
      borderRadius: 80,
      '&.Mui-selected': {
        borderRadius: 80,
        color: elementColor,
        backgroundColor: theme.color.greys[80],
        pointerEvents: 'none',
        '&.Mui-focusVisible': {
          ...focusStyle(theme, 2),
          backgroundColor: theme.color.greys[80],
        },
        '&:active': {
          backgroundColor: theme.color.greys[60],
        }
      },

      '&.Mui-focusVisible': {
        ...focusStyle(theme, 2),
        backgroundColor: 'unset',
      }
    },
    '& .MuiPaginationItem-page': {
      '&:hover': {
        color: elementColor,
        backgroundColor: theme.color.greys[80],
      },
      '&:active': {
        color: theme.color.constants.greys[0],
        backgroundColor: theme.color.greys[60],
      }
    }
  },
  selectBox: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
  },
  selectLabel: {
    paddingRight: 8,
    font: fontText('normal', theme.fontSize.base, 16),
    color: theme.color.greys[60],
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      font: fontText('normal', theme.fontSize.s, 16),
    }
  },
  paginationSelect: {
    minWidth: 'unset',
  }
})}, { name: 'Pagination', index: StylesIndexInjections.UI_ATOMS });
